var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24.951,
    viewBox: "0 0 25 24.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.619,10.708h7.131a.7.7,0,0,0,.7-.7V9.238a3.74,3.74,0,0,0-3.774-3.748,2.508,2.508,0,1,0-.985,0,3.74,3.74,0,0,0-3.774,3.748V10A.7.7,0,0,0,169.619,10.708Z",
    transform: "translate(-160.67)",
    fill: "#a6a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.815,112.036a.73.73,0,0,0,.851-.591,9.773,9.773,0,0,1,2.785-5.216.733.733,0,0,0-1.015-1.058,11.244,11.244,0,0,0-3.209,6.01.734.734,0,0,0,.589.854Z",
    transform: "translate(-49.665 -99.364)",
    fill: "#a6a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.016,108.573a9.647,9.647,0,0,1,1.014,2.87.732.732,0,1,0,1.44-.263,11.244,11.244,0,0,0-3.209-6.01.729.729,0,0,0-1.034.019.737.737,0,0,0,.019,1.039A9.631,9.631,0,0,1,371.016,108.573Z",
    transform: "translate(-351.003 -99.362)",
    fill: "#a6a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.463,363.961a9.514,9.514,0,0,1-2.956.475h-.04a9.566,9.566,0,0,1-2.9-.444.734.734,0,0,0-.441,1.4,11.014,11.014,0,0,0,3.339.512h.04a11,11,0,0,0,3.412-.549.734.734,0,0,0-.457-1.4Z",
    transform: "translate(-167.993 -345.677)",
    fill: "#a6a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.759,307.431a2.508,2.508,0,1,0-.985,0A3.74,3.74,0,0,0,0,311.179v.767a.7.7,0,0,0,.7.7H7.831a.7.7,0,0,0,.7-.7v-.767a3.739,3.739,0,0,0-3.774-3.749Z",
    transform: "translate(0 -287.198)",
    fill: "#a6a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.016,307.431a2.508,2.508,0,1,0-.985,0,3.739,3.739,0,0,0-3.774,3.748v.767a.7.7,0,0,0,.7.7h7.131a.7.7,0,0,0,.7-.7v-.767A3.74,3.74,0,0,0,342.016,307.431Z",
    transform: "translate(-320.789 -287.198)",
    fill: "#a6a9ac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleConnected);
export default __webpack_public_path__ + "static/media/people_connected.8deca4a90f51a875304659459b739a84.svg";
export { ForwardRef as ReactComponent };